/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Trouble_Win_Gpu_QInputs */

const en_wc_dl_trouble_win_gpu_q = /** @type {(inputs: Wc_Dl_Trouble_Win_Gpu_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows: the app flashes and closes`)
};

/**
* | output |
* | --- |
* | "Windows: the app flashes and closes" |
*
* @param {Wc_Dl_Trouble_Win_Gpu_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_trouble_win_gpu_q = /** @type {((inputs?: Wc_Dl_Trouble_Win_Gpu_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Trouble_Win_Gpu_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_trouble_win_gpu_q(inputs)
});
export { wc_dl_trouble_win_gpu_q as "wc.dl.trouble.win_gpu.q" }